export const REDUCERS = {
    // Views
    CURRENT_VIEW: "currentView",
    CURRENT_QUEUE: "currentQueue",

    // Batches
    BATCHES: "batches",
    SELECTED_BATCH: "selectedBatch",

    // Uploads
    UPLOADS: "uploads",
    UPLOAD_APPROVAL: "uploadApproval",
    UPLOAD_FOOTER_ACTIONS: "uploadFooterActions",
    LARGE_IMAGE_VIEW: "largeImageView",

    // Misc
    ANIMATIONS: "animations",
    MESSAGES: "messages"
};

export const UPLOAD_STATUSES = {
    VIS_MOD: "VISUAL_MOD",
    VIS_MOD_SAVED_FOR_LATER: "VISUAL_MOD_SAVED_FOR_LATER"
};

export const QUEUES = {
    VIS_MOD: "visMod",
    METADATA_MOD: "metadataMod",
    SUSPENDED: "suspended",
    COMPLETED: "completed"
};

export const LICENSE_MAPPINGS = {
    CREATIVECOMMONS: "Creative Commons",
    PUBLICDOMAIN: "Public Domain"
};

/*---------------------------
| Batches
---------------------------*/
export const BATCH_TYPE_KEYS = {
    NO_FLAGS: "no-flags",
    REL_EUO: "rel-euo",
    EXP_TXT: "exp-txt",
    SAVED: "saved",
    UNASSIGNED: "unassigned",
    MY_BATCHES: "my-batches"
};
/**
 * These optional filters have 3 state values
 * 1: Null: means that the filter is not applied
 * 2: True: adds filter where Batch HAS this attribute
 * 3: False: adds filter where Batch DOES NOT HAVE this attribute
 */
export const BATCH_TYPES = [
    {
        id: 1,
        key: BATCH_TYPE_KEYS.NO_FLAGS,
        label: `No Flags`,
        databaseVariable: "hasNoFlags"
    },
    {
        id: 2,
        key: BATCH_TYPE_KEYS.REL_EUO,
        label: `REL/EUO`,
        databaseVariable: "hasUploadsWithRelOrEuoFlag"
    },
    {
        id: 3,
        key: BATCH_TYPE_KEYS.EXP_TXT,
        label: `EXP/TXT`,
        databaseVariable: "hasUploadsWithExpOrTxtFlag"
    },
    {
        id: 4,
        key: BATCH_TYPE_KEYS.SAVED,
        label: `Saved`,
        databaseVariable: "hasSavedForLaterUploads"
    },
    {
        id: 5,
        key: BATCH_TYPE_KEYS.UNASSIGNED,
        label: `Unassigned`,
        databaseVariable: "isUnassigned"
    },
    {
        id: 6,
        key: BATCH_TYPE_KEYS.MY_BATCHES,
        label: `My Batches`,
        databaseVariable: "assignedToMe"
    }
];

/* sortBy ---------------------------*/
export const SORT_BY_VALUES = ["oldeset-to-newest", "newest-to-oldest"];
export const SORT_BY_OPTIONS = [
    {
        id: 1,
        key: "sortBy",
        value: SORT_BY_VALUES[0],
        text: "Oldest - Newest"
    },
    {
        id: 2,
        key: "sortBy",
        value: SORT_BY_VALUES[1],
        text: "Newest - Oldest"
    }
];

/*---------------------------
| Misc
---------------------------*/
/* Animations ---------------------------*/
export const ANIMATIONS = {
    BATCH_REMOVE: "batch-remove"
};

/*---------------------------
| Messaging
---------------------------*/
export const messaging = {
    errors: {
        containsDisallowedTerms: (field = "title") =>
            `Sorry, ${field} contains terms that are not allowed. Please try again.`
    }
};
